import React from 'react';
import LoadingCard from './Loading';

const DesktopWorksGrid = ({ worksData, loading, isVisible }) => {
  const getAnimationType = (index) => {
    const position = index % 3;
    if (position === 0) return 'slide-left';
    if (position === 1) return 'slide-center';
    return 'slide-right';
  };

  return (
    <div className="row g-4 desktop-grid">
      {loading ? (
        Array(6).fill(0).map((_, index) => (
          <LoadingCard key={index} />
        ))
      ) : (
        worksData.map((work, index) => {
          const animationDelay = `${0.5 + (index * 0.15)}s`;
          
          return (
            <div key={work.id} className="col-lg-4 col-md-6">
              <div className={`work-card h-100 animate-card ${isVisible ? 'visible' : ''} ${getAnimationType(index)}`}
                   style={{ animationDelay }}>
                
                {/* Project Image */}
                <div className="work-image-container">
                  <img 
                    src={work.image} 
                    alt={work.title}
                    className="work-image"
                    onError={(e) => {
                      e.target.src = "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=250&fit=crop";
                    }}
                  />
                  <div className="category-badge1">
                    {work.category}
                  </div>
                </div>

                {/* Card Content */}
                <div className="card-content">
                  <h1 className="card-title">
                    {work.title}
                  </h1>
                  
                  <h2 className="card-description">
                    {work.description}
                  </h2>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default DesktopWorksGrid;